import { CustomInitializer } from "src/modules/sm-base/shared/custom-initializer.interface";
import { Comparable } from "src/modules/utils/shared/comparable";
import { Objects } from "src/modules/utils/shared/objects";

export class ProjectCustomFieldDefinition implements CustomInitializer, Comparable<ProjectCustomFieldDefinition> {
    //netgen start
    title: string;
    order = 0;
    dropdownField = false;
    dropdownOptions: string[];
    id = 0;
    //netgen end

    customInitializer(): void {
        this.dropdownOptions ??= [];
    }
    
    compareTo(other: ProjectCustomFieldDefinition): number {
        return Objects.cmpMulti([this.order, other.order, this.title, other.title]);
    }
    
}
